const days = function (date) {
    let difference = new Date(date).getTime() - new Date().getTime();
    return Math.ceil(difference / (1000 * 3600 * 24));
}

export default {
    deep: true,
    bind: function (el) {
        let handler = function ( e ) {
            console.log(days('12/10/2020'));
        }

        el.addEventListener( 'input', handler );
    },
}